export const CURRENT_USER_PERMISSIONS_QUERY_KEY = 'currentUserPermissions';
